import { Component, OnInit } from '@angular/core';
import { IngredientService, Ingredient } from "app/services/ingredient.service";
import { TonalityService, Tonality } from '../../../services/tonality.service';
import { ColorShadeService, ColorShade } from '../../../services/color-shade.service';
import { PigmentService, Pigment } from '../../../services/pigment.service';
import { CategoryService, Category } from '../../../services/category.service';
import { Router, ActivatedRoute } from "@angular/router/";
import { BaseComponent } from "app/components/base.component";

declare var $: any;

@Component({
	selector: 'app-ingredients-bulk',
	templateUrl: './ingredients-bulk.component.html',
	styleUrls: ['./ingredients-bulk.component.css']
})
export class IngredientsBulkComponent extends BaseComponent implements OnInit {

	formTitle: string = "Bulk Add Products";
	buttonText: string = "Upload CSV File";

	modalTitle: string = "Product Detail";
	modalItem: Ingredient;

	detailFormTitle: string = "";
	detailFormLabelName: string = "";
	detailFormButtonTitle: string = "";
	detailItem =  new detailItemPopup();

	categories_assoc = [];
	tonalities_assoc = [];
	color_shade_assoc = [];
	pigment_assoc = [];
	temp_categories_assoc = [];
	temp_tonalities_assoc = [];
	temp_color_shade_assoc = [];
	temp_pigment_assoc = [];

	csvSelector: string = "csv-files";
	notif_msg: string = "";
	notif_type: string = "text-success";
	show_table: string = "";
	ok_to_upload: string = "";

	categories: Category[];
	categories_to_compare: any[];
	categories_to_compare_table: any[];
	tonalities_to_compare_table: any[];
	color_shade_to_compare_table: any[];
	pigment_to_compare_table: any[];
	ingredientsBulk: Ingredient[];
	tonalities: Tonality[];
	tonalities_to_compare: any[];
	colorShades: ColorShade[];
	colorShades_to_compare: any[];
	pigments: Pigment[];
	pigments_to_compare: any[];

	categories_map = {};

	constructor(
		private IngredientService: IngredientService,
		private categoryService: CategoryService,
		private tonalityService: TonalityService,
		private colorShadeService: ColorShadeService,
		private pigmentService: PigmentService
	) {
		super();
	}

	ngOnInit() {
		this.categoryService.getCategories().subscribe((categories) => {
			this.categories = categories;
			// indramdhani:create the assoc 
			this.categories.forEach(element => {
				this.categories_assoc[element.$key] = element;
			});
		});
		this.tonalityService.getTonalities().subscribe((tonalities) => {
			this.tonalities = tonalities;
			this.tonalities.forEach(element => {
				this.tonalities_assoc[element.$key] = element;
			});
		});
		this.colorShadeService.getColorShades().subscribe((colorShades) => {
			this.colorShades = colorShades;
			this.colorShades.forEach(element => {
				this.color_shade_assoc[element.$key] = element;
			});
		});
		this.pigmentService.getPigments().subscribe((pigments) => {
			this.pigments = pigments;
			this.pigments.forEach(element => {
				this.pigment_assoc[element.$key] = element;
			});
		});
	}

	formAction() {
		var complete = 0;
		this.ingredientsBulk.forEach((product, index )=> {
			product.category_id    = this.refine_before_upload("category_id", product, this.categories_to_compare);
			product.tonality_id    = this.refine_before_upload("tonality_id", product, this.tonalities_to_compare);
			product.color_shade_id = this.refine_before_upload("color_shade_id", product, this.colorShades_to_compare);
			product.pigment_id     = this.refine_before_upload("pigment_id", product, this.pigments_to_compare);

			this.IngredientService.updateIngredient(product.sap_code, product).then( result => {
				complete ++;
				if(complete >= this.ingredientsBulk.length){
					this.ingredientsBulk = [];
					var form_element     = <HTMLFormElement>document.getElementById("form-"+this.csvSelector);
					form_element.reset();
					this.notif_msg       = "Data has been successfully added";
					this.notif_type      = "text-success";
				}
			})
		});
	}

	refine_before_upload(the_field, original_data ,array_to_compare){
		var data_key = "";
		if(original_data[the_field])
		{
			var data_to_compare = original_data[the_field].trim().toLowerCase().replace(/\s|\.|-|_|\//g, '');
			array_to_compare.forEach(original => {
				var ori_to_compare = original.name.trim().toLowerCase().replace(/\s|\.|-|_|\//g, '');
				if(data_to_compare == ori_to_compare){
					data_key = original.key;
				}
			});
		}
		return data_key;
	}

	filechange(event: Event) {
		var self = this;
		var input = <HTMLInputElement>event.target;
		var file_name_element = <HTMLSpanElement>document.getElementById("file-used-" + self.csvSelector);
		var form_element = <HTMLFormElement>document.getElementById("form-" + self.csvSelector);
		this.notif_msg = '';
		var file = input.files[0];
		var r = new FileReader();
		r.readAsText(file);
		r.onloadend = function (e) {
			self.ingredientsBulk = [];
			self.categories_to_compare = [];
			self.categories_to_compare_table = [];
			self.tonalities_to_compare_table = [];
			self.color_shade_to_compare_table = [];
			self.pigment_to_compare_table = [];
			self.tonalities_to_compare = [];
			self.colorShades_to_compare = [];
			self.pigments_to_compare = [];
			file_name_element.innerHTML = file.name;
			form_element.reset();
			var csvData = r.result;
			try {
				var data = $.csv.toArrays(csvData);
				if (data && data.length > 0) {
					var is_csv_valid = true;
					data.forEach((element, index) => {
						element.forEach(array_element => {
							if (!array_element) {
								is_csv_valid = is_csv_valid && false;
							}
						});
						if(index > 0)
						{
							var data_list = {
								sap_code: element[0],
								category_id: self._category_mapping(element[1], element[2]),
								product_list: self._product_list_mapping(element[3]),
								product_name: element[4] ? element[4].trim() : null,
								color_shade_id: element[5],
								tonality_id: element[6] || null,
								gin: element[7] ? element[7].trim() : null,
								description: element[8] ? element[8].trim() : null,
								pigment_id: element[9],
								halal_status: self._halal_mapping(element[10]),
								product_status: self._product_status_mapping(element[11]),
								solubility: element[12] ? element[12].trim() : null,
								format: self._format_mapping(element[13]),
								application_suggestion: element[14] ? element[14].trim() : null,
								packaging_size: self._array_mapping(element[15]),
								moq: self._array_mapping(element[16]),
								shelf_life: self._shelf_life_mapping(element[17]),
								lead_time: self._lead_time_mapping(element[18]),
								price: self._price_mapping(element[19]),
								doc_spec: element[20] || null,
								doc_TDS: element[21] || null,
								doc_MSDS: element[22] || null,
								doc_halal: element[23] || null,
							};
							// indramdhani:category to compare
							if(data_list.category_id)
							{
								var category_to_compare = {
									name: data_list.category_id.trim(),
									key: ""
								}
								self.categories_to_compare.push(category_to_compare);
								self.categories_to_compare_table.push(category_to_compare);
							}
							// indramdhani:tonalityService to compare
							if(data_list.tonality_id)
							{
								var tonalityService_to_compare = {
									name: data_list.tonality_id.trim(),
									key: ""
								}
								self.tonalities_to_compare.push(tonalityService_to_compare);
								self.tonalities_to_compare_table.push(tonalityService_to_compare);
							}
							// indramdhani:ColorShade to compare
							if(data_list.color_shade_id)
							{
								var color_shade_to_compare = {
									name: data_list.color_shade_id.trim(),
									key: ""
								}
								self.colorShades_to_compare.push(color_shade_to_compare);
								self.color_shade_to_compare_table.push(color_shade_to_compare);
							}
							// indramdhani: pigments to compare
							if(data_list.pigment_id)
							{
								var pigment_to_compare ={
									name: data_list.pigment_id.trim(),
									key: ""
								}
								self.pigments_to_compare.push(pigment_to_compare);
								self.pigment_to_compare_table.push(pigment_to_compare);
							}
							self.ingredientsBulk.push(Object.assign(new Ingredient(), data_list));
						}
					});
					self.categories_to_compare = self.refine_result(self.categories_to_compare, self.categories);
					self.tonalities_to_compare = self.refine_result(self.tonalities_to_compare, self.tonalities);
					self.colorShades_to_compare = self.refine_result(self.colorShades_to_compare, self.colorShades);
					self.pigments_to_compare = self.refine_result(self.pigments_to_compare, self.pigments);
					if (!is_csv_valid) {
						self.notif_msg = "Some Fields are Empty";
						self.notif_type = "text-danger";
						self.show_table = "show-table";
						self.ok_to_upload = "ok_to_upload";
					}
					else {
						self.notif_msg = "";
						self.notif_type = "text-success";
						self.show_table = "show-table";
					}
				}
				else {
					self.show_table = "";
					self.notif_msg = "Empty file";
					self.notif_type = "text-danger";
				}
			} catch (error) {
				console.log(error);
				self.show_table = "";
				self.ok_to_upload = "";
				self.notif_msg = "Please upload CSV file.";
				self.notif_type = "text-danger";
			}
		}
	}

	change_category_map(item)
	{
		var complete = 0;
		this.categories_to_compare_table.forEach(element => {
			complete ++;
			this.temp_categories_assoc[element.name] = this.categories_assoc[element.key].name;
		});
	}

	change_tonality_map(item)
	{
		var complete = 0;
		this.tonalities_to_compare_table.forEach(element => {
			complete ++;
			this.temp_tonalities_assoc[element.name] = this.tonalities_assoc[element.key].name;
		});
	}

	change_color_shade_map(item)
	{
		var complete = 0;
		this.color_shade_to_compare_table.forEach(element => {
			complete ++;
			this.temp_color_shade_assoc[element.name] = this.color_shade_assoc[element.key].name;
		});
	}

	change_pigment_map(item)
	{
		var complete = 0;
		this.pigment_to_compare_table.forEach(element => {
			complete ++;
			this.temp_pigment_assoc[element.name] = this.pigment_assoc[element.key].name;
		});
	}

	trackByIndex(index: number, obj: any): any {
		return index;
	}

	onDeleteClick(index) {
		if(confirm("Are you sure?")){
			this.ingredientsBulk.splice(index,1);
		}
	}

	onviewClick(index){
		this.modalTitle  = 'Product Detail';
		this.modalItem = new Ingredient();
		this.modalItem = Object.assign(new Ingredient(), this.ingredientsBulk[index]);
	}

	onModalClick(link){
		window.open(link, "_blank");
	}

	clickAddTonality(){
		this.detailFormTitle = "Add New Tonality";
		this.detailFormLabelName = "Tonality Name";
		this.detailFormButtonTitle = "Save Tonality";
		this.detailItem.type = "tonality";
		this.detailItem.name = "";
	}

	clickAddColorShade(){
		this.detailFormTitle = "Add New Color Shade";
		this.detailFormLabelName = "Color Shade";
		this.detailFormButtonTitle = "Save Color Shade";
		this.detailItem.type = "colorshade";
		this.detailItem.name = "";
	}

	clickAddPigment(){
		this.detailFormTitle = "Add New Pigment";
		this.detailFormLabelName = "Pigment";
		this.detailFormButtonTitle = "Save Pigment";
		this.detailItem.type = "pigment";
		this.detailItem.name = "";
	}

	detailFormAction(){
		if(this.detailItem.name)
		{
			switch (this.detailItem.type) {
				case "tonality":
					var tonality_to_add = new Tonality();
					tonality_to_add.name = this.detailItem.name.trim();
					this.tonalityService.addTonality(tonality_to_add);
				break;
				case "colorshade":
					var colorShade_to_add = new ColorShade();
					colorShade_to_add.name = this.detailItem.name.trim();
					this.colorShadeService.addColorShade(colorShade_to_add);
				break;
				case "pigment":
					var pigment_to_add = new Pigment();
					pigment_to_add.name = this.detailItem.name.trim();
					this.pigmentService.addPigment(pigment_to_add);
				break;
				default:
				break;
			}
		}
		else
		{
			console.log("empty data, nothing to add");
		}
	}

	_product_list_mapping(originaldata: any) {
		var search = originaldata.toLowerCase().replace(/\-|list/ig, '').trim().match(/a|b|c/);
		return search ? search[0] : '';
	}

	_halal_mapping(originaldata: any) {
		var the_value: string = "";
		switch (originaldata.trim()) {
			case "Halal":
				the_value = "halal";
				break;
			case "Special Permit":
				the_value = "special-permit";
				break;
			case "Non Halal":
				the_value = "non-halal";
				break;
			default:
				the_value = null;
				break;
		}
		return the_value;
	}

	_product_status_mapping(originaldata: any) {
		var the_value: string = "";
		switch (originaldata.trim()) {
			case "Natural":
				the_value = "natural";
				break;
			case "Artificial":
				the_value = "artificial";
				break;
			default:
				the_value = null;
				break;
		}
		return the_value;
	}

	_format_mapping(originaldata: any){
		var the_value: string = "";
		switch (originaldata.trim()) {
			case "Liquid":
				the_value = "liquid";
			break;
			case "Powder": 
				the_value = "powder";
			break;
			case "Durarome": 
				the_value = "durarome";
			break
			default:
				the_value = originaldata.toLowerCase();
			break;
		}
		return the_value;
	}

	_price_mapping(originaldata: any) {
		var the_value: number = 0;
		if (originaldata) {
			originaldata = originaldata.trim().toLowerCase();
			originaldata = originaldata.replace(new RegExp(",", 'g'), "");
			originaldata = originaldata.replace("rp", "").trim();
			the_value = parseInt(originaldata);
		}
		return the_value ? the_value : null;
	}

	_shelf_life_mapping(originaldata: any) {
		var result = null;
		if (/\d.*month/.test(originaldata)) {
			result = originaldata.match(/(\d+)/)[1];
		}
		else if (/\d.*year/.test(originaldata)) {
			result = originaldata.match(/(\d+)/)[1] * 12;
		}
		else
		{
			result = parseInt(originaldata);
		}
		return result ? parseInt(result) : null;
	}

	_lead_time_mapping(originaldata: any) {
		if (originaldata) 
		{
			return originaldata;
		}
		return null;
	}

	_array_mapping(originaldata: any) {
		if (originaldata) {
			var array_split = originaldata.split(',');
			if (array_split) {
				var to_return = new Array();
				array_split.forEach(element => {
					if (/\d+/.test(element)) {
						var temp_result = element.match(/(\d+)/)[1];
						temp_result = temp_result.trim();
						to_return.push(temp_result);
					}
				});
			}
			return to_return;
		}
		return null;
	}

	_category_mapping(category: any, subcategory: any) {
		var to_return = category;
		if (subcategory) {
			to_return = subcategory;
		}
		return to_return.trim();
	}

	refine_result(data_to_compare, originaldata){
		data_to_compare = this.multiDimensionalUnique(data_to_compare);
		data_to_compare.forEach((element_to_compare, index) => {
			var the_key = "";
			// if(element_to_compare.name)
			// {
				var name_to_compare = element_to_compare.name.trim().toLowerCase().replace(/\s|\.|-|_|\//g, '');
				originaldata.forEach(category => {
					var ori_to_compare = category.name.trim().toLowerCase().replace(/\s|\.|-|_|\//g, '');
					if(name_to_compare == ori_to_compare){
						the_key = category.$key;
					}
				});
				data_to_compare[index].key = the_key;
			// }
		});
		return data_to_compare;
	}

	multiDimensionalUnique(arr) {
		var uniques = [];
		var itemsFound = {};
		for(var i = 0, l = arr.length; i < l; i++) {
			var stringified = JSON.stringify(arr[i]);
			if(itemsFound[stringified]) { continue; }
			uniques.push(arr[i]);
			itemsFound[stringified] = true;
		}
		return uniques;
	}
}


export class detailItemPopup {
	name?: string = '';
	type?: string = "";
}


// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/ingredient/ingredients-bulk/ingredients-bulk.component.ts